export default __webpack_public_path__ + "static/media/home-page-banner@2x.fbfe9d76.png";